import axios from "axios";
import constants from "../constants";
import { EventBus } from './event-bus.js';

export default {
    getDraftList(defId) {
        if(defId.includes(".")){
            defId = defId.split(".")[0];
        }
        axios.defaults.withCredentials = true;
        return axios.get(constants.BASE_URL + "/partial-form-data/process-drafts/"+ defId, {
            withCredentials: true
        }).then(response => {
            return response.data;
        });
    },
    getDraftById(draftId) {
        axios.defaults.withCredentials = true;
        var msgType = "updateSuccess";
        return axios.get(constants.BASE_URL + "/partial-form-data/"+ draftId, {
            withCredentials: true
        }).then(response => {
            return response.data;
        }).catch(error => {
            msgType = "updateError";
        }).finally(() => {
            if (msgType == 'updateError') {
                EventBus.$emit('error-notification', {
                    "msg": "Error while loading draft data"
                });
            }
        });
    },
    getMyProcesses(input) {
        axios.defaults.withCredentials = true;
        var msgType = "updateSuccess";
        return axios.get(constants.BASE_URL + "/processesAPI/getProcessInfo?" + input, {
            withCredentials: true
        }).then(response => {
            return response.data;
        }).catch(error => {
            msgType = "updateError";
        }).finally(() => {
            if (msgType == 'updateError') {
                EventBus.$emit('error-notification', {
                    "msg": "Error while fetching processes"
                });
            }
        });
    },
    getProcessData(input, filterVariables) {
        axios.defaults.withCredentials = true;
        var msgType = "updateSuccess";
        return axios.post(constants.BASE_URL + "/processesAPI/getAllProcessList?" + input, filterVariables, {
            withCredentials: true
        }).then(response => {
            return response.data;
        }).catch(error => {
            msgType = "updateError";
        }).finally(() => {
            if (msgType == 'updateError') {
                EventBus.$emit('error-notification', {
                    "msg": "Error while fetching processes"
                });
            }
        });
    },
    getUsers() {
        axios.defaults.withCredentials = true;
        var msgType = "updateSuccess";
        return axios.get(constants.BASE_URL + "/processesAPI/getAllUsers?", {
            withCredentials: true
        }).then(response => {
            return response.data;
        }).catch(error => {
            msgType = "updateError";
        }).finally(() => {
            if (msgType == 'updateError') {
                EventBus.$emit('error-notification', {
                    "msg": "Error while getting users"
                });
            }
        });
    },
    getDeployedProcesses(categoryName) {
        axios.defaults.withCredentials = true;
        var msgType = "updateSuccess";
        return axios.get(constants.BASE_URL + "/category/" + categoryName, {
            withCredentials: true
        }).then(response => {
            return response.data;
        }).catch(error => {
            msgType = "updateError";
        }).finally(() => {
            if (msgType == 'updateError') {
                EventBus.$emit('error-notification', {
                    "msg": "Error while getting deployed processes"
                });
            }
        });
    },
    getFormForProcesses(definitionId, isExternal) {
        axios.defaults.withCredentials = true;
        var msgType = "updateSuccess";
        return axios.get(isExternal ? constants.BASE_URL + "/standalone/external/processesAPI/getFormForProcesses/" + definitionId : constants.BASE_URL + "/processesAPI/getFormForProcesses/" + definitionId, {
            withCredentials: true
        }).then(response => {
            return response.data;
        }).catch(error => {
            msgType = "updateError";
        }).finally(() => {
            if (msgType == 'updateError') {
                EventBus.$emit('error-notification', {
                    "msg": "Error while getting form data"
                });
            }
        });
    },
    submitProcessStartForm(url, obj) {
        axios.defaults.withCredentials = true;
        var msgType = "updateSuccess";
        return axios.post(url, obj, {
            withCredentials: true,
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }).then(response => {
            return response.data;
        }).catch(error => {
            msgType = "updateError";
        }).finally(() => {
            if (msgType == 'updateError') {
                EventBus.$emit('error-notification', {
                    "msg": "Error while submitting form data"
                });
            }
        });
    },
    getDataFromDataList(dataListName) {
        axios.defaults.withCredentials = true;
        var msgType = "updateSuccess";
        return axios.get(constants.BASE_URL + "/custom-data-list/renderer-data/" + dataListName, {
            withCredentials: true
        }).then(response => {
            return response.data;
        }).catch(error => {
            msgType = "updateError";
        }).finally(() => {
            if (msgType == 'updateError') {
                EventBus.$emit('error-notification', {
                    "msg": "Error while fetching data lists"
                });
            }
        });
    },
    getDataForEsysAdapter(obj) {
        axios.defaults.withCredentials = true;
        var msgType = "updateSuccess";
        return axios.get(constants.BASE_URL + '/adapters/parseVariableValues' + obj, {
            withCredentials: true
        }).then(response => {
            return response.data;
        }).catch(error => {
            msgType = "updateError";
        }).finally(() => {
            if (msgType == 'updateError') {
                EventBus.$emit('error-notification', {
                    "msg": "Error while fetching data lists"
                });
            }
        });
    },
    getDataListsFromAdapter(url) {
        axios.defaults.withCredentials = true;
        var msgType = "updateSuccess";
        return axios.get(constants.BASE_URL + url, {
            withCredentials: true
        }).then(response => {
            return response.data;
        }).catch(error => {
            msgType = "updateError";
        }).finally(() => {
            if (msgType == 'updateError') {
                EventBus.$emit('error-notification', {
                    "msg": "Error while fetching data lists"
                });
            }
        });
    },
    getDataForAPILookupService(url) {
        axios.defaults.withCredentials = true;
        var msgType = "updateSuccess";
        return axios.get(constants.BASE_URL + url, {
            withCredentials: true
        }).then(response => {
            return response.data;
        }).catch(error => {
            msgType = "updateError";
        }).finally(() => {
            if (msgType == 'updateError') {
                EventBus.$emit('error-notification', {
                    "msg": "Error while fetching data for API lookup"
                });
            }
        });
    },
}
